import Animated, { FadeIn, FadeOut } from "react-native-reanimated";
import { useMedia } from "tamagui";

import CuraiConversation from "@/conversation/CuraiConversation";

type ConvoWrapperProps = {
  conversationId: string;
};

export default function CuraiConvoWrapper({
  conversationId,
}: ConvoWrapperProps) {
  const { lg } = useMedia();
  if (lg) {
    return (
      <Animated.View
        style={{ flex: 1 }}
        entering={FadeIn.duration(150)}
        exiting={FadeOut.duration(150)}
      >
        {conversationId && (
          <CuraiConversation conversationId={conversationId} />
        )}
      </Animated.View>
    );
  }
}
